import Image, { StaticImageData } from "next/image";


export const TitleIcon = ({
    img,
    title,
    styles
}: {
    img: StaticImageData;
    title: string;
    styles: any
}) => {
    return (
        <h3 className={styles.title_whith_img}>
            <span className={styles.title_span}>{title}</span>
            <Image src={img} alt="title" />
        </h3>
    );
};